import { COLORS } from "@/constants";

type ArrowRightProps = {
  $borderColor?: keyof typeof COLORS;
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
} & React.SVGProps<SVGSVGElement>;

export const ArrowRight: React.FC<ArrowRightProps> = ({
  $borderColor,
  width = 21,
  height = 21,
  stroke,
  fill,
  ...rest
}) => {
  const color = $borderColor ? COLORS[$borderColor] : stroke || "#E0E8F8";

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.99414 2.50702C5.99416 2.19725 6.11695 1.89993 6.33594 1.68085C6.55502 1.46186 6.85234 1.33907 7.16211 1.33905C7.47186 1.33905 7.76918 1.46189 7.98828 1.68085L16.3301 10.0226C16.549 10.2417 16.6718 10.5391 16.6719 10.8488C16.6719 11.1586 16.5491 11.4559 16.3301 11.675L7.99219 20.0129C7.77212 20.2244 7.47814 20.3416 7.17285 20.3391C6.86659 20.3364 6.57306 20.2138 6.35645 19.9973C6.13983 19.7806 6.01732 19.4872 6.01465 19.1808C6.01201 18.8777 6.12638 18.585 6.33496 18.3654L6.33594 18.3654L13.8525 10.8488L13.499 10.4953L6.33594 3.33319C6.11698 3.1141 5.99414 2.81677 5.99414 2.50702Z"
        fill={fill || color}
        stroke={color}
      />
    </svg>
  );
};